// Actor name below is used to find access token required to start reminder service in Ember: app/services/ais.js. Those names have to be the same here and in Ember file.
export const DEBT_COLLECTION_ACTOR_NAME = 'Advokaternes Inkasso Service integration'

export const DEBT_COLLECTION_ACTOR_DESCRIPTION = 'Used by Advokaternes Inkasso Service integration. Do not edit.'
